import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../service/login/login.service';
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-service-example',
  templateUrl: './service-example.component.html',
  styleUrls: ['./service-example.component.css']
})
export class ServiceExampleComponent implements OnInit {

  constructor(private service: LoginService, private router: Router) { }

  ngOnInit() {
  }

  case(num: number) {
    switch (num) {
      case 1:
        localStorage.setItem('type', "案例展示")
        this.router.navigate(["/serviceExample/serviceCase"])
        break
    }

  }

}
